import React, { useEffect, useRef, useState } from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { instance } from '../../store/utils';
import { useDispatch, useSelector } from "react-redux";
import { isBeneficiary, isCoe, isKtP, isMinistry, isProvider } from "utils";
import { checkUser, getTaxisData, getUser } from "store/user/actions";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";

const Reports = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const user = useSelector(state => state.user);
  const groups = useSelector(state => state.user?.groups);
  const userType = groups && (isMinistry(groups) || isCoe(groups)) ? "ministry" : "";
  const [url, setUrl] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState("");
  const [tabList, setTabList] = useState([]);
  const defaultList = ["Search Vouchers"];
  const [usersList, setUsersList] = useState([]);
  const canViewPage = !isBeneficiary(groups);

  const getPowerBiLink = async () => {
    return await instance.get(`/app/rest/reports/${userType}`).then(response => {
      return response;
    });
  };

  const navigateToPage = async (pageName) => {
    setActivePage(pageName);
    const report = reportRef.current?._embed;
    if (report) {
      const pages = await report.getPages();
      const page = pages.find(p => p.displayName === pageName);
      if (page) {
        await page.setActive();
      }
    }
  };

  useEffect(() => {
    if (userType) {
      getPowerBiLink().then((data) => {
        setToken(data.data.embedToken.token);
        setUrl(data.data.embedReports.embedUrl);
      });
    }
  }, [userType]);

    const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        }
      },
      background: models.BackgroundType.Transparent,
      navContentPaneEnabled: false,
      localeSettings: {
        language: 'el',
        formatLocale: 'el-GR'
      }
    }
  });

  useEffect(() => {
    if (token !== "" && url !== "") {
      setReportConfig({
        ...reportConfig,
        embedUrl: url,
        accessToken: token,
        id: url
          .toString()
          .substring(
            url.toString().indexOf('=') +
            1,
            url.toString().indexOf('&')
          ),
        filters: []
      })
      setLoading(false);
    }
  }, [token, url]);

  // useEffect(() => {
  //   dispatch(checkUser(navigate));
  //   dispatch(getUser());
  //   dispatch(getTaxisData());
  // }, [dispatch, navigate]);

  useEffect(() => {
    if (!canViewPage) navigate("/appTrack", { replace: true });
    setUsersList(defaultList);
  }, [user]);

  // const applyConditionalFilters = (report) => {
  //   report.getActivePage().then((page) => {
  //     // if (page.displayName !== "Search Vouchers") {
  //     //   if (userType === "provider") {
  //     //     const filters = [
  //     //       {
  //     //         $schema: "http://powerbi.com/product/schema#basic",
  //     //         target: {
  //     //           table: "provider_offer",
  //     //           column: "provider",
  //     //         },
  //     //         operator: "In",
  //     //         values: [user?.info?.provider],
  //     //       },
  //     //     ];
  //     //     report.setFilters(filters);
  //     //   } else {
  //     //     report.setFilters([]);
  //     //   }
  //     // } else {
  //     report.setFilters([]);
  //     // }
  //   });
  // };

  // useEffect(() => {
  //   const report = reportRef.current?._embed;

  //   if (report && reportConfig.embedUrl && reportConfig.accessToken && usersList.length > 0) {
  //     report.on('loaded', async () => {
  //       await navigateToPage(usersList[0]);
  //       applyConditionalFilters(report);
  //     });
  //     report.on("pageChanged", () => {
  //       applyConditionalFilters(report);
  //     });
  //   }
  // }, [reportConfig, user]);

  useEffect(() => {
    switch(userType) {
      case "ministry":
        setTabList(["Overview", "Applications", "By Geographic Area", "Focus", "Bank"]);
        setActivePage("Overview");
        break;
      default:
        setTabList([]);
    }
  }, [user]);

  return (
    loading ?
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Spin size="large" />
      </div>
      :
      <div className="powerbi-report-style-class-wrapper">
        <div className="custom-nav">
          {tabList.map((item) => (
          <button
            className={tabList.length > 1 && activePage === item ? "active" : ""}
            onClick={() => navigateToPage(item)}
            key={item}
          >
            {item}
          </button>
        ))}
        </div>
        <div className="powerbi-report-style-class">
          <PowerBIEmbed
            ref={reportRef}
            cssClassName={'report-style-class'}
            embedConfig={reportConfig}
          />
        </div>
      </div>
  );
};

export default Reports;
